export const RESULT_LAYOUT = Object.freeze({
  header: Object.freeze({
    title: Object.freeze({ x: 640, y: 48 }),
    subtitle: Object.freeze({ x: 640, y: 76 }),
  }),
  card: Object.freeze({
    centerX: 640,
    centerY: 285,
    width: 440,
    height: 350,
  }),
  cardOffsets: Object.freeze({
    badge: Object.freeze({ y: -142 }),
    winnerLabel: Object.freeze({ y: -110 }),
    name: Object.freeze({ y: -74 }),
    department: Object.freeze({ y: -48 }),
    preview: Object.freeze({ y: 110 }),
  }),
  actions: Object.freeze({
    rematch: Object.freeze({ x: 640, y: 508, width: 280, height: 44 }),
    characterSelect: Object.freeze({ x: 640, y: 566, width: 280, height: 38 }),
    title: Object.freeze({ x: 640, y: 618, width: 280, height: 34 }),
  }),
  colors: Object.freeze({
    bg: 0x080d19,
    cardBg: 0x0f172a,
    cardBorder: 0x334155,
    p1Accent: 0x38bdf8,
    p2Accent: 0xf97316,
    cpuAccent: 0x94a3b8,
    drawAccent: 0x64748b,
    salesTheme: 0x38bdf8,
    developerTheme: 0xf472b6,
  }),
});
